import { IconUser } from '@tabler/icons';

const dashboard = {
  id: 'agent',
  title: 'Agents',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Agent',
      type: 'item',
      url: '/agent/default',
      icon: IconUser,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
